import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { SyfLoader } from 'syf-component-library/ui/atoms';
import { Stack } from 'syf-component-library/ui/spacing';
import Alert from '../../components/Alert';
import { DeliveryDetails, Note, RequestDetails, SummaryHeading } from '../../components/SummaryDetails';
import useConfig from '../../context/config.context';
import useSteps from '../../context/steps.context';
import withAuth from '../../hoc/withAuth';
import useAccountSummary from '../../hooks/useAccountSummary';
import useCardholders from '../../hooks/useCardholders';
import useFeatureFlagsQuery from '../../hooks/useFeatureFlagsQuery';
import { useReplaceMultipleCardsQuery } from '../../hooks/useReplaceCardQuery';
import { t } from '../../translations/getTranslation';
import { useStore } from '../../zustandStore/store';
const BodyWrapper = styled.div `
  padding: ${({ theme }) => theme.spacing.base}px;
  padding-bottom: ${({ theme }) => theme.spacing.large}px;

  @media ${query.greaterThanMedium} {
    padding: ${({ theme: { spacing } }) => `${spacing.xlarge}px ${spacing.huge}px`};
  }
`;
const LoadingWrapper = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const ReviewDamagedCard = withAuth(() => {
    const { selectedCardholders } = useCardholders('SelectAccount');
    const { accountId, triggerAnalyticsEvent } = useConfig();
    const { stepsDispatch } = useSteps();
    const { updateReplacedCardholders } = useStore();
    const { mutate, isLoading } = useReplaceMultipleCardsQuery();
    const { data: featureFlags } = useFeatureFlagsQuery();
    const { accountName, isSuccess, isSemu } = useAccountSummary();
    useEffect(() => {
        if (!isSuccess) {
            return;
        }
        triggerAnalyticsEvent({
            messageType: isSemu ? 'semu' : 'nonsemu',
            pageFunction: 'replace your card',
            pageSubFunction: 'damaged card',
            pageName: 'review',
            pageKind: 'account services',
            message: 'Once you submit this request it can’t be reversed. You can continue using your account until the new card arrives.'
        });
    }, [triggerAnalyticsEvent, isSuccess, isSemu]);
    /* istanbul ignore next -- @preserve */
    const handleSubmit = () => {
        stepsDispatch({ type: 'updateRequestLoading', payload: true });
        mutate({
            'cipher.accountId': accountId,
            accountIdType: 'guid',
            cardDetails: selectedCardholders.map(cardholder => ({
                paymentInstrumentReferenceId: cardholder.id
            }))
        }, {
            onSuccess: ({ cards }) => {
                const replacedCardholders = cards.map(card => {
                    const [currentCardholder] = selectedCardholders.filter(cardholder => cardholder.id === card.paymentInstrumentReferenceId);
                    return Object.assign(Object.assign({}, currentCardholder), { replaced: card.isCardReplaced });
                });
                updateReplacedCardholders(replacedCardholders);
                stepsDispatch({ type: 'nextStep' });
            },
            onError: _error => {
                stepsDispatch({ type: 'updateStep', payload: 'UnableSubmit' });
            },
            onSettled: () => {
                stepsDispatch({ type: 'updateRequestLoading', payload: false });
            }
        });
    };
    useEffect(() => {
        stepsDispatch({
            type: 'updateRequest',
            payload: handleSubmit
        });
        /* eslint-disable-next-line */
    }, []);
    return isLoading ? (_jsx(LoadingWrapper, { children: _jsx(SyfLoader, { size: 4.375 }) })) : (_jsxs(_Fragment, { children: [_jsx(SummaryHeading, {}), _jsxs(BodyWrapper, { children: [_jsx(Alert, Object.assign({ variant: "info" }, { children: t('summaryDetails.onceYouSubmit') })), _jsx(Stack, { size: "large" }), _jsx(RequestDetails, { accountName: accountName || '', cardholders: selectedCardholders }), _jsx(Stack, { size: "large" }), (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.config.flags.showNote) && (_jsxs(_Fragment, { children: [_jsx(Note, { noteMessage: t('summaryDetails.note') }), _jsx(Stack, { size: "large" })] })), _jsx(DeliveryDetails, {})] })] }));
});
//# sourceMappingURL=DamagedCard.js.map